module.exports = __webpack_public_path__ + "static/media/Slide2.689ed5a5.png";